// eslint-disable-next-line no-unused-vars
import ClientPayClassClassificationViewModel from '@/models/client/clientPayClassClassificationViewModel'
import { ModelApiService } from './BaseApiService'

export default class ClientApiService extends ModelApiService {
  constructor() {
    super('Client')
  }

  async getGroup(ids) {
    var payload = { Ids: ids, Type: 'GROUP' }
    return await this.post(`search/heirachy`, payload)
  }

  async getClient(ids) {
    var payload = { Ids: ids, Type: 'CLIENT' }
    return await this.post(`search/heirachy`, payload)
  }

  async getLocation(ids) {
    var payload = { Ids: ids, Type: 'LOCATION' }
    return await this.post(`search/heirachy`, payload)
  }

  /**
   * Retrieves a list of sub bubble agreements for a client
   * @returns {Promise<SubBubbleAgreementViewModel[]>}
   */
  async getSubBubbleAgreements(clientId) {
    return await this.get(`${clientId}/sub-bubble-agreements`)
  }

  /**
   * Retrieves a list of pay class classifications for Client
   * @returns {Promise<ClientPayClassClassificationViewModel[]>}
   */
  async getPayClassClassifications(clientId) {
    return await this.get(`${clientId}/pay-class-classifications`)
  }
}
